import normalize from '../normalizer';

const ERROR_CODES = {
  1: 'Multi-factor authentication is required',
  3: 'Invalid Credentials',
  4: 'This account is locked out',
  5: 'Password change is required',
  7: 'Access to Agent Portal has been disabled for your user account. Please contact your agency administrator to adjust permissions.',
  8: 'Your agency has not enabled access to Agent Portal. Please contact your agency administrator or enable Agent Portal via the Marketplace.'
};

export default function (response) {
  if (authFailed(response)) {
    return normalize({
      ok: false,
      status: response.status ? response.status : 500,
      message: ERROR_CODES[response.data.status] || 'An error occurred while processing the request',
      data: null
    });
  } else {
    return normalize({
      ok: true,
      status: response.status,
      message: null,
      data: response.data
    });
  }
}

function authFailed (response) {
  return !response.data ||
    response.status !== 200 ||
    (response.data.status && Object.keys(ERROR_CODES).map(Number).includes(response.data.status));
}
